var config  = require('../../config');
window.__config = config;
module.exports = config;



// WEBPACK FOOTER //
// src/lib/config.js